import { IPersistenceStorage } from '../Auth/TokenStorage';

export class AuthPersistenceStorage implements IPersistenceStorage {
  get(key: string) {
    return sessionStorage.getItem(key) ?? undefined;
  }

  set(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  clear(key: string): void {
    sessionStorage.removeItem(key);
  }
}
